import React from 'react';
import { graphql } from 'gatsby';
import './eventLayout.scss';
import './article.scss';
import Container from '../components/container';
import Layout from '../components/Layout';
import { EventDetails } from '../components/featuredEvent';
import { EventPageQueryInterface } from '../data/StrapiEvent';
import { useLocation } from '@reach/router';
import SEO from '../components/seo';
import ReactMarkdown from 'react-markdown/with-html';
import Img from 'gatsby-image';
import CtaForArticle from '../components/CtaForArticle';
import EventTags from '../commons/EventTags';
import Speaker from '../commons/Speaker';
import twitterIcon from '../assets/twitter.svg';
import linkedInIcon from '../assets/linkedin_article.svg';
import facebookIcon from '../assets/facebook_article.svg';
import AllEvents from '../components/AllEvents';
import slugIt from '../utils/slugIt';

export const query = graphql`
  query EventQuery($id: Int!) {
    event: strapiEvents(strapiId: { eq: $id }) {
      id
      name
      date
      eventUrl
      description
      type
      eventVideo
      shortDescription
      event_speaker {
        linkedinHandle
        id
        description
        name
        twitterHandle
        profileImage {
          childImageSharp {
            fluid(maxWidth: 50, maxHeight: 50) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      banner {
        childImageSharp {
          fluid(maxWidth: 600, maxHeight: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  }
`;

const EventLayout: EventPageQueryInterface = ({
  data: {
    event: { name, date, banner, description, event_speaker, eventVideo, shortDescription },
  },
}) => {
  const { pathname } = useLocation();
  return (
    <div>
      <Layout
        dontShowSEO
        dontShowCTA
        coverImage={banner.childImageSharp.fluid.src}
        pageTitle={name}
      >
        <SEO
          description={shortDescription}
          coverImg={banner.childImageSharp.fluid.src}
          title={name}
          pathname={pathname}
        />
        <Container className="articleContainerPadding">
          <div className="articleContainer">
            <div className="articleContainerMetaData eventLayoutContainerMetaData">
              <div>
                <EventTags eventTime={date} />
                <h1>{name}</h1>
                <p className="eventLayoutContainerMetaDataShortDescription">{shortDescription}</p>
                <div className="eventLayoutContainerSpeakerAndSocialContainer">
                  <Speaker
                    speakerName={event_speaker.name}
                    description={event_speaker.description}
                    linkedInURL={event_speaker.linkedinHandle}
                    twitterURL={event_speaker.twitterHandle}
                    profileImage={event_speaker.profileImage.childImageSharp.fluid}
                  />
                  <EventDetails
                    title="Share"
                    details={
                      <div style={{ display: 'flex' }}>
                        <div
                          style={{ cursor: 'pointer', marginRight: 20 }}
                          onClick={() =>
                            window.open(
                              `http://twitter.com/share?text=${name}&url=${
                                process.env.GATSBY_TWITTER_URL_PREFIX
                              }/fourthact/events/${slugIt(name)}`,
                              '_blank',
                            )
                          }
                        >
                          <img src={twitterIcon} height="22px" alt="twitter-icon" />
                        </div>
                        <div
                          style={{ cursor: 'pointer', marginRight: 20 }}
                          onClick={() =>
                            window.open(
                              `https://www.linkedin.com/shareArticle?url=${
                                process.env.GATSBY_TWITTER_URL_PREFIX
                              }/fourthact/events/${slugIt(name)}&title=${name}`,
                              '_blank',
                            )
                          }
                        >
                          <img src={linkedInIcon} height="22px" alt="linkedin-icon" />
                        </div>
                        <div
                          style={{ cursor: 'pointer', marginRight: 10 }}
                          onClick={() =>
                            window.open(
                              `http://www.facebook.com/sharer.php?u=${
                                process.env.GATSBY_TWITTER_URL_PREFIX
                              }/fourthact/events/${slugIt(name)}${pathname}`,
                              '_blank',
                            )
                          }
                        >
                          <img src={facebookIcon} height="22px" alt="facebook-icon" />
                        </div>
                      </div>
                    }
                  />
                </div>
              </div>
            </div>
            {date.toString() >= new Date().toISOString() && banner ? (
              <div className="articleContainerImageContainer">
                <Img fluid={banner.childImageSharp.fluid} />
              </div>
            ) : (
              <div className="eventLayoutIframeContainer">
                <iframe
                  className="eventLayoutIframeContainerIframe"
                  src={eventVideo}
                  allow="autoplay; fullscreen"
                  allowFullScreen
                />
              </div>
            )}
            <div className="articleContainerContent">
              <div className="articleContainerContentMarkdown">
                <ReactMarkdown escapeHtml={false} source={description} />
              </div>
            </div>
            {date.toString() >= new Date().toISOString() && (
              <div className="articleCtaContainer">
                <CtaForArticle />
              </div>
            )}
          </div>
        </Container>
        <Container className="featuredEventContainerPadding lightBlueBG">
          <AllEvents title="All Events" />
        </Container>
      </Layout>
    </div>
  );
};

export default EventLayout;
